/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindViewsQueryResponse,
  FindViewsQueryParams,
} from "../types/FindViews.ts"

export const findViewsQueryKey = (params: FindViewsQueryParams) =>
  [{ url: "/v1/view/find-views" }, ...(params ? [params] : [])] as const

export type FindViewsQueryKey = ReturnType<typeof findViewsQueryKey>

/**
 * @summary Find views
 * {@link /v1/view/find-views}
 */
export async function findViews(
  params: FindViewsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindViewsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/view/find-views`, params, ...requestConfig })
  return res
}

export function findViewsQueryOptions(
  params: FindViewsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findViewsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindViewsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindViewsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findViews(params, config)
    },
  })
}

/**
 * @summary Find views
 * {@link /v1/view/find-views}
 */
export function useFindViews<
  TData = ResponseConfig<FindViewsQueryResponse>,
  TQueryData = ResponseConfig<FindViewsQueryResponse>,
  TQueryKey extends QueryKey = FindViewsQueryKey,
>(
  params: FindViewsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindViewsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findViewsQueryKey(params)

  const query = useQuery(
    {
      ...findViewsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
